/* Correcteur de densite pour l'article "calcul volume demenagement".
 *
 * Constantes issues de donnees publiees par Dressing Malin :
 *  - carton livre 34x26x32 cm = 28 L, rempli a moitie = 14 L utiles
 *  - carton vaisselle, remplissage aux deux tiers calage compris, sur un
 *    format standard de 57 L
 *  - permis B : 3,5 t de PTAC, soit 20 a 23 m3 chez les loueurs
 *
 * UNE seule hypothese ajoutee, affichee dans l'interface et non cachee ici :
 *  1 m de rayonnage x 25 cm de profondeur x 22 cm de hauteur utile = 55 L.
 *
 * On ne calcule QUE ce qui se derive. Pas de nombre de cartons standards :
 * il faudrait connaitre la part de mobilier dans le volume, information que
 * nous n'avons pas. Le renvoi se fait vers les kits par taille de logement.
 *
 * Le formulaire vit entierement dans le HTML : ce script ne fait que calculer.
 * Sans JS, le contenu reste lisible et indexable.
 */
(function () {
  'use strict';

  var LIVRES_PAR_METRE_L = 55;
  var CARTON_LIVRE_UTILE_L = 14;
  var CARTON_LIVRE_EXTERNE_L = 28;
  var CARTON_VAISSELLE_L = 57;
  var PART_UTILE_VAISSELLE = 2 / 3;
  var PLAFOND_PERMIS_B_M3 = 23;

  function arrondiSup(x) {
    return Math.ceil(x - 1e-9);
  }

  function fmt(x) {
    return x.toFixed(1).replace('.', ',');
  }

  function init(racine) {
    var elSurface = racine.querySelector('[data-dm-surface]');
    var elMetres = racine.querySelector('[data-dm-metres]');
    var elVaisselle = racine.querySelector('[data-dm-vaisselle]');
    var outBrut = racine.querySelector('[data-dm-brut]');
    var outCorrige = racine.querySelector('[data-dm-corrige]');
    var outEcart = racine.querySelector('[data-dm-ecart]');
    var outPhrase = racine.querySelector('[data-dm-phrase]');
    var outAlerte = racine.querySelector('[data-dm-alerte]');

    if (!elSurface || !outCorrige) return;

    function calcule() {
      var surface = parseFloat(elSurface.value) || 0;
      var metres = parseFloat(elMetres.value) || 0;
      var nbVaisselle = parseFloat(elVaisselle.value) || 0;

      var brut = surface / 2;

      // Livres. Leur volume propre est deja compris dans l'estimation brute :
      // on n'ajoute que le surplus d'encombrement une fois mis en cartons.
      var livresL = metres * LIVRES_PAR_METRE_L;
      var cartonsLivre = arrondiSup(livresL / CARTON_LIVRE_UTILE_L);
      var surplusLivres = (cartonsLivre * CARTON_LIVRE_EXTERNE_L - livresL) / 1000;
      if (surplusLivres < 0) surplusLivres = 0;

      // Vaisselle. L'utilisateur donne un nombre de cartons : le surplus est
      // la part non utile de chaque carton, calage compris.
      var surplusVaisselle = (nbVaisselle * CARTON_VAISSELLE_L * (1 - PART_UTILE_VAISSELLE)) / 1000;

      var corrige = brut + surplusLivres + surplusVaisselle;
      var ecart = corrige - brut;

      outBrut.textContent = fmt(brut) + ' m³';
      outCorrige.textContent = fmt(corrige) + ' m³';
      outEcart.textContent = (ecart > 0 ? '+' : '') + fmt(ecart) + ' m³';

      var phrase;
      if (surface <= 0) {
        phrase = 'Renseignez votre surface habitable pour lancer le calcul.';
      } else {
        phrase = 'Estimation brute ' + fmt(brut) + ' m³. En tenant compte de la densité, comptez ' + fmt(corrige) + ' m³ à charger dans le camion.';
        if (cartonsLivre > 0) {
          phrase += ' Vos livres demandent environ ' + cartonsLivre + ' carton' + (cartonsLivre > 1 ? 's' : '') + ' de 28 litres, remplis à moitié.';
        }
      }
      outPhrase.textContent = phrase;

      var alerte = '';
      if (surface > 0) {
        if (brut <= PLAFOND_PERMIS_B_M3 && corrige > PLAFOND_PERMIS_B_M3) {
          alerte = 'Sans la correction vous restiez sous les ' + PLAFOND_PERMIS_B_M3 + ' m³ du permis B. Avec, vous passez au-dessus : c’est là que se décide le second voyage.';
        } else if (corrige > PLAFOND_PERMIS_B_M3) {
          alerte = 'Au-delà de ' + PLAFOND_PERMIS_B_M3 + ' m³, comptez deux voyages en permis B, un poids lourd, ou un déménageur.';
        }
      }
      outAlerte.textContent = alerte;
      outAlerte.hidden = !alerte;
    }

    [elSurface, elMetres, elVaisselle].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', calcule);
      el.addEventListener('change', calcule);
    });

    calcule();
  }

  function demarrer() {
    var noeuds = document.querySelectorAll('[data-dm-simu]');
    for (var i = 0; i < noeuds.length; i++) init(noeuds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
